(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('sellerActivityConstants', {
            ACTIVITY_STATUS: {
                PENDING: 'PENDING',
                DOING: 'DOING',
                CANCELLED: 'CANCELLED',
                DONE: 'DONE',
                EXPIRED: 'EXPIRED'
            }
        });
})();
